import _ from 'lodash';
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';
import { object, string } from 'yup';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormResource from '../FormResource.jsx';

const defaults = {
  itemCode: '',
  gdn: '',
  status: '',
  orgId: null,
  design: {},
  supplier: {},
  uom: '',
  meta: {},
  remarks: '',
  prices: {
    tradePriceRate: 100,
    retailPrice: 0,
    tradePrice: 0,
    currency: '',
  },
  location: '',
  showroom: '',
};
const schema = object({
  status: string(),
  remarks: string(),
  location: string(),
  showroom: string(),
});

const FormStock = ({ stock }) => {
  const api = '/api/core/restocks';

  const [showroomRes, showroomReq] = useHttpStatus();
  React.useEffect(() => {
    showroomReq({ url: '/api/core/users/self/showrooms' });
  }, []);
  return (
    <PageHttp res={showroomRes}>
      {(showrooms) => (
        <FormResource
          {...{
            defaults,
            schema,
            segment: 'stocks',
            stored: stock,
            api,
            onSubmit: (submit) => {
              const v = _.pick(submit, ...[
                'status',
                'remarks',
                'location',
                'showroom',
              ]);
              return {
                ...v,
              };
            },
          }}>
          <Tabs defaultActiveKey="basic" unmountOnExit>
            <Tab eventKey="basic" title="Basic">
              <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
              <div className="row">
                <div className="col">
                  <FormGroup name="itemCode" disabled />
                </div>
                <div className="col">
                  <FormGroup name="gdn" disabled />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="status" as="select">
                    <option value=""> - </option>
                    {(env?.status?.restocks || []).map((v) => (
                      <option value={v} key={v}>
                        {_.startCase(v)}
                      </option>
                    ))}
                  </FormGroup>
                </div>
                <div className="col">
                  <FormGroup name="orgId" label="Organization ID" disabled />
                </div>
              </div>
              <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">ADDITIONAL</h6>
              <div className="row">
                <div className="col">
                  <FormGroup name="design.brand" label="Brand" disabled />
                </div>
                <div className="col">
                  <FormGroup name="design.coll.name" label="Collection" disabled />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="design.design" label="Design" disabled />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="remarks" />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label>Preview</label>
                    <img
                      className='w-100'
                      src={stock.arImg || `/api/core/restocks/${stock._id}/preview.svg`}
                      alt={'s'}
                    />
                  </div>
                </div>
                <div className="col">
                </div>
                <div className="col">
                </div>
                <div className="col">
                </div>
              </div>
            </Tab>
            <Tab eventKey="measurement" title="Measurement">
              <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DIMENSION</h6>
              <div className="row">
                <div className="col">
                  <FormGroup name="uom" disabled />
                </div>
                <div className="col">
                  <FormGroup name="meta.material" label="Material" disabled />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="meta.width" label="Carpet Width" disabled />
                </div>
                <div className="col">
                  <FormGroup name="meta.length" label="Carpet Length" disabled />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="meta.unit" label="Unit" disabled />
                </div>
                <div className="col">
                </div>
              </div>
            </Tab>
            <Tab eventKey="sales" title="Sales">
              <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">PRICES</h6>
              <div className="row">
                <div className="col">
                  <FormGroup name="prices.retailPrice" label="Retail Price" disabled />
                </div>
                <div className="col">
                  <FormGroup name="prices.tradePrice" label="Trade Price" disabled />
                </div>
                <div className="col">
                  <FormGroup name="prices.currency" as="select" disabled>
                    <option value=""> - </option>
                    {env.currencies.map(({ code, symbol }) => (
                      <option value={code} key={code}>
                        {`${_.startCase(code)} - ${symbol}`}
                      </option>
                    ))}
                  </FormGroup>
                </div>
              </div>
              <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">SALES</h6>
              <div className="row">
                <div className="col">
                  <FormGroup name="location" />
                </div>
                <div className="col">
                  <FormGroup
                    name="showroom"
                    label="Showroom Code"
                    as="select">
                    <option value="">-</option>
                    {showrooms.map((v) => (
                      <option value={v._id} key={v._id}>
                        {`${v.orgId} - ${v.showrmCode}`}
                      </option>
                    ))}
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name="supplier.name" label="Supplier" disabled />
                </div>
              </div>
            </Tab>
          </Tabs>
        </FormResource>
      )}
    </PageHttp>
  );
};

export default FormStock;
